import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

type IntlTaxColumnProps = {
  fulfillmentId: string;
};

const IntlTaxColumn = ({ fulfillmentId }: IntlTaxColumnProps) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelFulfillment } = fulfillment;

  if (!labelFulfillment?.intlTax) {
    return '';
  }

  const { value, code } = labelFulfillment.intlTax;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

type ColumnData =
  | {
      id: string;
    }
  | null
  | undefined;

export const intlTax = {
  getMessageDescriptor: () => messages.tax,
  id: 'intlTax',
  render: (data: ColumnData) => {
    if (!data) {
      return '';
    }
    return <IntlTaxColumn fulfillmentId={data.id} />;
  },
};
